var popular = require('./popular.js');
var winner_dc = require('./winner_dc.js');
var ht_ft = require('./ht_ft.js');
var under_over = require('./under_over.js');
var total_goals = require('./total_goals.js');
var correct_score_1 = require('./correct_score_1.js');
var correct_score_2 = require('./correct_score_2.js');
var final_score_and_total_goals = require('./final_score_and_total_goals.js');
var gg_ng_and_odd_even = require('./gg_ng_and_odd_even.js');
var home_goals = require('./home_goals.js');
var away_goals = require('./away_goals.js');
var home_under_over = require('./home_under_over.js');
var away_under_over = require('./away_under_over.js');
var final_score_and_under_over_1 = require('./final_score_and_under_over_1.js');
var final_score_and_under_over_2 = require('./final_score_and_under_over_2.js');
var gg_ng_and_under_over = require('./gg_ng_and_under_over.js');
var dc_and_gg_ng = require('./dc_and_gg_ng.js');
var first_half_score = require('./first_half_score.js');
var more_odds_listener = require('../../listeners/more-odds-listener');
var other_score_modals = require('./other-score-modal');

var oddsArr = [
'popular', 
'winner_dc', 
'ht_ft',
'under_over',
'total_goals', 
'correct_score_1', 
'correct_score_2', 
'final_score_and_total_goals', 
'gg_ng_and_odd_even', 
'home_goals', 
'away_goals', 
'home_under_over', 
'away_under_over',
'final_score_and_under_over_1',
'final_score_and_under_over_2',
'gg_ng_and_under_over',
'dc_and_gg_ng',
'first_half_score' ];

module.exports = {
  draw: function (quotes) {
    other_score_modals.refresh();
    other_score_modals.render(quotes);
    setHeaders();   
    $.each(quotes, function( index, value ) {
        $('#popular').append(popular.gamesHtml(index+1, value));
        $('#winner_dc').append(winner_dc.gamesHtml(index+1, value));
        $('#ht_ft').append(ht_ft.gamesHtml(index+1, value));
        $('#under_over').append(under_over.gamesHtml(index+1, value));
        $('#total_goals').append(total_goals.gamesHtml(index+1, value));
        $('#correct_score_1').append(correct_score_1.gamesHtml(index+1, value));
        $('#correct_score_2').append(correct_score_2.gamesHtml(index+1, value));
        $('#final_score_and_total_goals').append(final_score_and_total_goals.gamesHtml(index+1, value));
        $('#gg_ng_and_odd_even').append(gg_ng_and_odd_even.gamesHtml(index+1, value));
        $('#home_goals').append(home_goals.gamesHtml(index+1, value));
        $('#away_goals').append(away_goals.gamesHtml(index+1, value));
        $('#home_under_over').append(home_under_over.gamesHtml(index+1, value));
        $('#away_under_over').append(away_under_over.gamesHtml(index+1, value));
        $('#final_score_and_under_over_1').append(final_score_and_under_over_1.gamesHtml(index+1, value));
        $('#final_score_and_under_over_2').append(final_score_and_under_over_2.gamesHtml(index+1, value));
        $('#gg_ng_and_under_over').append(gg_ng_and_under_over.gamesHtml(index+1, value));
        $('#dc_and_gg_ng').append(dc_and_gg_ng.gamesHtml(index+1, value));
        $('#first_half_score').append(first_half_score.gamesHtml(index+1, value));
    });

    more_odds_listener.listen();
    setDisabledBets();
  }
}

function setHeaders(){
    
    $.each(oddsArr, function( index, value ) {
        $('#'+value).html('');
    })
    
    $('#popular').append(popular.haderHtml());
    $('#winner_dc').append(winner_dc.haderHtml());
    $('#ht_ft').append(ht_ft.haderHtml());
    $('#under_over').append(under_over.haderHtml());
    $('#total_goals').append(total_goals.haderHtml());
    $('#correct_score_1').append(correct_score_1.haderHtml());
    $('#correct_score_2').append(correct_score_2.haderHtml());
    $('#final_score_and_total_goals').append(final_score_and_total_goals.haderHtml());
    $('#gg_ng_and_odd_even').append(gg_ng_and_odd_even.haderHtml());
    $('#home_goals').append(home_goals.haderHtml());
    $('#away_goals').append(away_goals.haderHtml());
    $('#home_under_over').append(home_under_over.haderHtml());
    $('#away_under_over').append(away_under_over.haderHtml());
    $('#final_score_and_under_over_1').append(final_score_and_under_over_1.haderHtml());
    $('#final_score_and_under_over_2').append(final_score_and_under_over_2.haderHtml());
    $('#gg_ng_and_under_over').append(gg_ng_and_under_over.haderHtml());
    $('#dc_and_gg_ng').append(dc_and_gg_ng.haderHtml());
    $('#first_half_score').append(first_half_score.haderHtml());
}

function setDisabledBets(){
     $('.disabled-bet').parent().addClass('gt-odds-disabled');
}


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/odds.js
// module id = 2002
// module chunks = 4